// extracted by mini-css-extract-plugin
module.exports = {"appContainer":"Home_appContainer__3P2fP"};